import { makeVar, useReactiveVar } from '@apollo/client';

export const filterVisibilityVar = makeVar<boolean>(false);
export const useFilterVisibility = () => useReactiveVar(filterVisibilityVar);
